module.exports = __webpack_public_path__ + "assets/mail.0aa7d95e.svg";